export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';

export const eventsData = {
  'Exhibition Opening': {
    date: 'Fri Oct 13 2023 19:00:00 GMT+0200',
    time: '19:00 - 21:00',
  },
  'Art and Fashion: Luxury brands inspired by classical art': {
    date: 'Tue Oct 17 2023 19:00:00 GMT+0200',
    time: '19:00 - 21:00',
  },
  'Contemporary Art in Perfume': {
    date: 'Fri Oct 27 2023 19:00:00 GMT+0200',
    time: '19:00 - 21:00',
  },
  'Drinking Art and Art of Drinking': {
    date: 'Fri Nov 10 2023 19:00:00 GMT+0200',
    time: '19:00 - 21:00',
  },
  'Chef’s Table - Art of Cooking': {
    date: 'Fri Nov 17 2023 19:00:00 GMT+0200',
    time: '19:00 - 21:00',
  },
};
